import YesIcon from 'assets/images/yes-icon.svg';

import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';

import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/logo-footer.svg';
import FooterWatermark from 'assets/images/footer-watermark.svg';
import SubscribiliLogo from 'assets/images/logo-subscribili.svg';

import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
} = process.env;

const locations = [
  { key: 'LOC1', name: 'Alexandra Dental Clinic' },
  { key: 'LOC2', name: 'Allington Dental Clinic' },
  { key: 'LOC3', name: 'Amelia Street Dental Clinic' },
  { key: 'LOC4', name: 'Arnott Hill Dental Clinic' },
  { key: 'LOC5', name: 'Avenue Dental Clinic' },
  { key: 'LOC6', name: 'Beckton Dental Clinic' },
  { key: 'LOC7', name: 'Bexhill Dental Clinic' },
  { key: 'LOC8', name: 'Broxtowe Lane Dental Clinic' },
  { key: 'LOC9', name: 'Buntingford Dental Clinic' },
  { key: 'LOC10', name: 'Cambourne Dental Clinic' },
  { key: 'LOC11', name: 'Cambridge Court Dental Clinic' },
  { key: 'LOC12', name: 'Care Platinum Dental Clinic' },
  { key: 'LOC13', name: 'Care Dental Dental Clinic' },
  { key: 'LOC14', name: 'Charlton Dental Clinic' },
  { key: 'LOC15', name: 'Chichele Dental Clinic' },
  { key: 'LOC16', name: 'Church Hill Dental Clinic' },
  { key: 'LOC17', name: 'Clevedon Dental Clinic' },
  { key: 'LOC18', name: 'Corby Dental Clinic' },
  { key: 'LOC19', name: 'Creekside Dental Clinic' },
  { key: 'LOC20', name: 'Crowborough Dental Clinic' },
  { key: 'LOC21', name: 'Diplomat House Dental Clinic' },
  { key: 'LOC22', name: 'Earls Court Dental Clinic' },
  { key: 'LOC23', name: 'Firs Dental Dental Clinic' },
  { key: 'LOC24', name: 'Folkestone Dental Clinic' },
  { key: 'LOC25', name: 'Frinton Dental Clinic' },
  { key: 'LOC26', name: 'Gaskell Avenue Dental Clinic' },
  { key: 'LOC27', name: 'Gayton Dental Clinic' },
  { key: 'LOC28', name: 'Gravesend Dental Clinic' },
  { key: 'LOC29', name: 'Great Knightleys Dental Clinic' },
  { key: 'LOC30', name: 'Halford House Dental Clinic' },
  { key: 'LOC31', name: 'Halton House Dental Clinic' },
  { key: 'LOC32', name: 'Handside Dental Clinic' },
  { key: 'LOC33', name: 'Hanlon & Gardner Dental Clinic' },
  { key: 'LOC34', name: 'Heathfield Dental Clinic' },
  { key: 'LOC35', name: 'Highview Dental Clinic' },
  { key: 'LOC36', name: 'HollyBush Dental Clinic' },
  { key: 'LOC37', name: 'Honor Oak Dental Clinic' },
  { key: 'LOC38', name: 'Horsham Dental Clinic' },
  { key: 'LOC39', name: 'Kenton Dental Dental Clinic' },
  { key: 'LOC40', name: 'Leyton Road Dental Clinic' },
  { key: 'LOC41', name: 'Little London Dental Clinic' },
  { key: 'LOC42', name: 'Lower Hayes Dental Clinic' },
  { key: 'LOC43', name: 'Maidstone Dental Clinic' },
  { key: 'LOC44', name: 'Manor Dental Clinic' },
  { key: 'LOC45', name: 'Market Place Dental Clinic' },
  { key: 'LOC46', name: 'Mawsley Dental Clinic' },
  { key: 'LOC47', name: 'Moat Road Dental Clinic' },
  { key: 'LOC48', name: 'Northgate Dental Clinic' },
  { key: 'LOC49', name: 'Norwood Dental Clinic' },
  { key: 'LOC50', name: 'Oval Dental Clinic' },
  { key: 'LOC51', name: 'Park Lane Dental Clinic' },
  { key: 'LOC52', name: 'Peckham Dental Clinic' },
  { key: 'LOC53', name: 'Pinhoe Dental Dental Clinic' },
  { key: 'LOC54', name: 'Portland Road Dental Clinic' },
  { key: 'LOC55', name: 'Portland Street Dental & Implant Practice' },
  { key: 'LOC56', name: 'Preston Park Dental Clinic' },
  { key: 'LOC57', name: 'Rodney Dental Dental Clinic' },
  { key: 'LOC58', name: 'Rosebank Dental Clinic' },
  { key: 'LOC59', name: 'Selhurst Dental Clinic' },
  { key: 'LOC60', name: 'Snodland Dental Clinic' },
  { key: 'LOC61', name: 'Southdown Dental Clinic' },
  { key: 'LOC62', name: 'St Albans Dental Clinic' },
  { key: 'LOC63', name: 'Stoke Newington Dental Clinic' },
  { key: 'LOC64', name: 'Stone Cross Dental Clinic' },
  { key: 'LOC65', name: 'Tilgate Dental Clinic' },
  { key: 'LOC66', name: 'Totton Dental Clinic' },
  { key: 'LOC67', name: 'Triangle Dental Clinic' },
  { key: 'LOC68', name: 'Vicarage Lane Dental Clinic' },
  { key: 'LOC69', name: 'Well Street Dental Clinic' },
  { key: 'LOC70', name: 'Welldene Dental Clinic' },
  { key: 'LOC71', name: 'Westpole Dental Clinic' },
  { key: 'LOC72', name: 'Williams Dental Clinic' },
  { key: 'LOC73', name: 'Wolverhampton Dental Clinic' },
  { key: 'LOC74', name: 'Wood Green Dental Clinic' },
  { key: 'LOC75', name: 'Wootton Road Dental Clinic' },
  { key: 'LOC76', name: 'Yeovil Dental Clinic' },
]

const locationApptLinks = locations.map((loc) => {
  const {
    [`REACT_APP_${loc.key}_APPT_LINK`]: locApptLink,
  } = process.env;
  return {
    name: loc.name,
    link: locApptLink,
    target: '_blank',
  };
});

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Colosseum Dental',
  tokenName: 'colosseumSubscriberToken',
  globalClass: 'colosseum-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  headerProps: {
    enable: true,
    showLogin: true,
    showSignupButton: false,
    buttonProps: {
      to: '/',
      scrollTo: 'pricing-benefit-section',
    },
  },
  enableUk: true,
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      preTitleClasses: 'home-hero-pretitle',
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      inputProps: {
        enable: true,
        scrollTo: 'find-provider-home-section',
        searchFilterKey: 'zipcode',
      },
      primaryButtonProps: {
        scrollTo: 'pricing-benefit-section',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'secondary',
        variant: 'contained',
      },
      background: '/images/home-images/colosseum-hero-image.webp',
      backgroundMobile: '/images/home-images/home-banner-img-mobile.webp',
    },
    benefitsSection: {
      variant: 2,
      columns: 3,
      alignCard: 'center',
      alignTitle: 'center',
      heroImage: '/images/home-images/colosseum-benefits.webp',
      buttonProps: {
        align: 'center',
        scrollTo: 'find-provider-home-section',
      },
    },
    subscriptionSection: {
      enable: false,
      priority: 'bottom',
      cardVariant: 1,
      tabVariant: 2,
      tabLabel: {
        annual: 'Billed Annually',
        annual_billed_monthly: 'Billed Monthly',
      },
      planCardProps: {
        buttonProps: {
          normalColor: 'primary',
          highlightedColor: 'primary',
          normalVariant: 'contained',
          highlightedVariant: 'outlined',
        },
      },
    },
    howItWorksSection: {
      variant: 3,
      alignTitle: 'center',
      heroImage: '/images/home-images/how-it-works.webp',
    },
    faqSection: {
      enable: true,
      variant: 1,
      buttonProps: {
        enable: true,
        align: 'left',
        to: '/faq',
        color: 'primary',
        variant: 'contained',
      },
    },
    testimonialSection: {
      enable: false,
    },
    contactSection: {
      enable: true,
    },
    findProviderOnHome: {
      enable: true,
      configuredFrequency: 'Monthly',
      showPlansOnDeepLink: true,
    },
  },
  checkoutSection: {
    intialfrequency: 'annual_billed_monthly'
  },
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
    iconProps: {
      url: '/images/map-loc-icon.svg',
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 1,
    tabVariant: 2,
    tabLabel: {
      annual: 'Billed Annually',
      annual_billed_monthly: 'Billed Monthly',
    },
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      title: 'Frequently asked questions',
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: false,
    secondaryButtonProps: {
      variant: 'outlined',
      color: 'primary',
    },
  },
  savingsSummary: {
    enableFooterbar: true,
    contactSection: 'contactDetails',
    moreSavingsButtonProps: {
      variant: 'contained',
      color: 'primary',
    },
  },
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  footer: {
    enable: true,
    variant: 2,
    hideFooterText: true,
    hideMiddleNav: true,
    logo: FooterLogo,
    scrollTo: 'find-provider-home-section',
    watermarkImage: FooterWatermark,
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme,
};

export default config;
